import React from 'react';
import PageContainerAuth from '../../components/common/PageContainerAuth';
import DocumentCreateSection from '../../components/pages/documents/create/DocumentCreateSection';

export default function DocumentCreate() {
    return (
        <PageContainerAuth section="mailings-attachs-add" pageTitle="Nouvelle Pièce jointe">
            <DocumentCreateSection/>
        </PageContainerAuth>
    );
}